import { cn } from "@omni/utils/styles";

export type DeliveryTypeTitleProps = {
    title: string;
    subTitle?: string;
};

const DeliveryTypeTitle = ({ title, subTitle }: DeliveryTypeTitleProps) => {
    return (
        <div>
            <p className={cn("tw:w-full tw:font-bold tw:text-lg")}>{title}</p>
            {subTitle && (
                <p className={cn("tw:w-full tw:font-light tw:text-sm")}>
                    {subTitle}
                </p>
            )}
        </div>
    );
};

export { DeliveryTypeTitle };
